import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { GlobalDateProvider } from "./contexts/GlobalDateContext";
import ProtectedRoute from "./components/ProtectedRoute";
import ErrorBoundary from "./components/ErrorBoundary";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Campaigns from "./pages/Campaigns";
import CampaignDetail from "./pages/CampaignDetail";
import Clients from "./pages/Clients";
import ClientWorkspace from "./pages/ClientWorkspace";
import AccountWorkspace from "./pages/AccountWorkspace";
import LandingPages from "./pages/LandingPages";
import LandingPageDetail from "./pages/LandingPageDetail";
import Leads from "./pages/Leads";
import AIInsights from "./pages/AIInsights";
import Alerts from "./pages/Alerts";
import Tasks from "./pages/Tasks";
import CalendarPage from "./pages/CalendarPage";
import Budget from "./pages/Budget";
import Admin from "./pages/Admin";
import Profile from "./pages/Profile";
import SyncLogs from "./pages/SyncLogs";

// Wrap every protected route with ErrorBoundary so a render-time crash on
// any single page (e.g. an unexpected API payload) shows a friendly
// fallback instead of a blank white screen.
const Guarded = ({ children }) => (
  <ProtectedRoute><ErrorBoundary>{children}</ErrorBoundary></ProtectedRoute>
);

export default function App() {
  return (
    <AuthProvider>
      <GlobalDateProvider>
        <BrowserRouter>
          <Toaster position="top-right" />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Guarded><Dashboard /></Guarded>} />
            <Route path="/campaigns" element={<Guarded><Campaigns /></Guarded>} />
            <Route path="/campaigns/:id" element={<Guarded><CampaignDetail /></Guarded>} />
            <Route path="/clients" element={<Guarded><Clients /></Guarded>} />
            <Route path="/clients/:id" element={<Guarded><ClientWorkspace /></Guarded>} />
            <Route path="/accounts/:id" element={<Guarded><AccountWorkspace /></Guarded>} />
            <Route path="/landing-pages" element={<Guarded><LandingPages /></Guarded>} />
            <Route path="/landing-pages/:id" element={<Guarded><LandingPageDetail /></Guarded>} />
            <Route path="/leads" element={<Guarded><Leads /></Guarded>} />
            <Route path="/ai-insights" element={<Guarded><AIInsights /></Guarded>} />
            <Route path="/alerts" element={<Guarded><Alerts /></Guarded>} />
            <Route path="/tasks" element={<Guarded><Tasks /></Guarded>} />
            <Route path="/calendar" element={<Guarded><CalendarPage /></Guarded>} />
            <Route path="/budget" element={<Guarded><Budget /></Guarded>} />
            <Route path="/admin" element={<Guarded><Admin /></Guarded>} />
            <Route path="/profile" element={<Guarded><Profile /></Guarded>} />
            <Route path="/sync-logs" element={<Guarded><SyncLogs /></Guarded>} />
          </Routes>
        </BrowserRouter>
      </GlobalDateProvider>
    </AuthProvider>
  );
}
